import { useMemo } from 'react';
import { TaskTypeEnum } from '../../enums/TaskTypeEnum';

interface UseTaskCompletionStatusProps {
  item: any;
  isOnline?: boolean;
}

export function useTaskCompletionStatus({
  item,
  isOnline = true,
}: UseTaskCompletionStatusProps) {
  return useMemo(() => {
    const taskTypeKey = item?.taskTypeKey;
    const isInProgressStatus = item?.status === 'in_progress';

    // Legal Metrology tasks allow Mark as Completed whenever in_progress
    if (taskTypeKey === TaskTypeEnum.LEGAL_METROLOGY_INSPECTION) {
      return {
        isAllPresentationsCompleted: true,
        canMarkAsCompleted: isInProgressStatus,
        isMarkAsCompletedDisabled: !isOnline,
      };
    }

    // Consumer Price Inspection tasks require all presentations to be completed
    const isAllPresentationsCompleted = !!item?.isAllPresentationsCompleted;
    const canMarkAsCompleted = isInProgressStatus && isAllPresentationsCompleted;
    const isMarkAsCompletedDisabled = !isOnline;

    return {
      isAllPresentationsCompleted,
      canMarkAsCompleted,
      isMarkAsCompletedDisabled,
    };
  }, [item?.taskTypeKey, item?.status, item?.isAllPresentationsCompleted, isOnline]);
}
